const _excluded = ["children", "initialValues"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { createContext, useContext } from 'react';
import { CookieProvider } from './CookieContext.js';
import { jsx } from 'react/jsx-runtime';
const TrackingManagerContext = /*#__PURE__*/createContext(null);
const useTrackingManager = () => {
  const options = useContext(TrackingManagerContext);
  if (!options) throw new Error('Cookie manager not provided');
  return options;
};
function Provider(_ref) {
  let children = _ref.children,
    initialValues = _ref.initialValues,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(TrackingManagerContext.Provider, {
    value: restProps,
    children: /*#__PURE__*/jsx(CookieProvider, {
      initialValues: initialValues,
      children: children
    })
  });
}
export { Provider, useTrackingManager };
//# sourceMappingURL=TrackingManagerContext.js.map
